export default "__VITE_ASSET__80af6cf2__"